module.exports = __webpack_public_path__ + "img/ic-add-attachment.b259c7d0.svg";